<template>
  <NuxtLink
    v-if="to"
    :to="to"
    :class="[$attrs.class, variantClass, colorClass]"
    v-bind="$attrs"
  >
    <UiIcon
      v-if="icon && iconPosition === 'left'"
      :name="icon"
      :class="[
        !noMargin ? 'mr-2 shrink-0' : '',
        resolvedIconColorClass,
        iconClass,
      ]"
      :size="iconSize"
    />
    <span v-if="label">{{ label }}</span>
    <UiIcon
      v-if="icon && iconPosition === 'right'"
      :name="icon"
      :class="[
        !noMargin ? 'ml-2 shrink-0' : '',
        resolvedIconColorClass,
        iconClass,
      ]"
      :size="iconSize"
    />
    <UiIcon
      v-if="icon && iconPosition === 'center'"
      :name="icon"
      :class="[!noMargin ? 'shrink-0' : '', resolvedIconColorClass, iconClass]"
      :size="iconSize"
    />
    <slot />
  </NuxtLink>

  <button
    v-else
    ref="button"
    v-bind="$attrs"
    :class="[$attrs.class, variantClass, colorClass]"
  >
    <UiIcon
      v-if="icon && iconPosition === 'left'"
      :name="icon"
      :class="[
        !noMargin ? 'mr-2 shrink-0' : '',
        resolvedIconColorClass,
        iconClass,
      ]"
      :size="iconSize"
    />
    <span v-if="label">{{ label }}</span>
    <UiIcon
      v-if="icon && iconPosition === 'right'"
      :name="icon"
      :class="[
        !noMargin ? 'ml-2 shrink-0' : '',
        resolvedIconColorClass,
        iconClass,
      ]"
      :size="iconSize"
    />
    <UiIcon
      v-if="icon && iconPosition === 'center'"
      :name="icon"
      :class="[!noMargin ? 'shrink-0' : '', resolvedIconColorClass, iconClass]"
      :size="iconSize"
    />
    <slot />
  </button>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

const props = defineProps<{
  to?: string;
  label?: string;
  icon?: string;
  iconClass?: string;

  /**
   * New:
   * - pass "var(--color-mode-icon)" and it becomes "text-[var(--color-mode-icon)]"
   * - if omitted, icon follows current text color
   */
  iconColor?: string;

  iconPosition?: "left" | "right" | "center";
  variant?: string;
  color?: string;
  noMargin?: boolean;
  iconSize?: "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
}>();

const button = ref<HTMLElement | null>(null);

const variantClass = computed(() => `btn-${props.variant ?? ""}`);
const colorClass = computed(() => `btn-${props.variant}--${props.color ?? ""}`);

/**
 * If iconColor is provided we render a Tailwind arbitrary value class.
 * Example: iconColor="var(--color-mode-icon)" -> text-[var(--color-mode-icon)]
 */
const resolvedIconColorClass = computed(() => {
  return props.iconColor ? `text-[${props.iconColor}]` : "text-current";
});
</script>
